import React, { useState } from 'react';
import { InstagramIcon, ShoppingBagIcon, MenuIcon, XIcon } from 'lucide-react';
import { brand } from '../data/brand';
import { AnnouncementBar } from './AnnouncementBar';
const navItems = [{
  label: 'Collections',
  href: '#collections'
}, {
  label: 'Best Sellers',
  href: '#best-sellers'
}, {
  label: 'About Us',
  href: '#founder'
}, {
  label: 'FAQ',
  href: '#faq'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full" data-id="element-120" data-mp="2wk732jnrl9sl">
      <AnnouncementBar data-id="element-121" data-mp="2wiw0gn622832" />

      <div className="border-b border-line bg-white" data-id="element-122" data-mp="31bfchfp3gv5r">
        <div className="relative mx-auto max-w-editorial px-5 md:px-12 lg:px-20" data-id="element-123" data-mp="31e1u685p8r1p">
          <div className="flex items-center justify-between py-2" data-id="element-124" data-mp="36aiib2cwf5es">
            <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="-ml-2 flex h-9 w-9 items-center justify-center text-maroon md:hidden" data-id="element-125" data-mp="3baxu3phj84un">
              {menuOpen ? <XIcon className="h-5 w-5" strokeWidth={1.4} data-id="element-126" data-mp="2rnuioppk0sic" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.4} data-id="element-127" data-mp="2mmx1afcdc2hw" />}
            </button>

            <div className="ml-auto flex items-center gap-4" data-id="element-128" data-mp="2hpeq0iavpb6q">
              <a href={brand.instagramHref} target="_blank" rel="noreferrer" aria-label={`Instagram ${brand.instagram}`} className="flex items-center gap-1.5 text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-129" data-mp="3fbluls76n3j3">
                <InstagramIcon className="h-[17px] w-[17px]" strokeWidth={1.4} data-id="element-130" data-mp="30lwmte4l419u" />
                <span className="hidden font-sans text-[10px] tracking-[0.12em] lg:inline" data-id="element-131" data-mp="1x7nm5neimqs">
                  {brand.instagram}
                </span>
              </a>
              <button type="button" aria-label="Shopping cart, 0 items" className="relative flex h-9 w-9 items-center justify-center text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep" data-id="element-132" data-mp="1rdtcbws5s14w">
                <ShoppingBagIcon className="h-[18px] w-[18px]" strokeWidth={1.4} data-id="element-133" data-mp="1hlxfsq5q0j2s" />
                <span className="absolute right-0.5 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-gold font-sans text-[9px] font-medium text-white" data-id="element-134" data-mp="1ml0dtqna9p19">
                  0
                </span>
              </button>
            </div>
          </div>

          <nav aria-label="Primary" className="hidden pb-5 pt-1 md:block" data-id="element-135" data-mp="ypxmnc10b9hm">
            <ul className="flex items-center justify-center gap-10 lg:gap-14" data-id="element-136" data-mp="13nqu08e1q9jh">
              {navItems.map(item => <li key={item.href} data-id="element-137" data-mp="2t3yirp569ie0">
                  <a href={item.href} className="whitespace-nowrap font-sans text-[11px] uppercase tracking-luxe text-maroon transition-colors duration-150 ease-luxe hover:text-gold-deep focus-visible:text-gold-deep focus-visible:outline-none" data-id="element-138" data-mp="2t0u7y8x7boed">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        {menuOpen && <nav aria-label="Mobile" className="border-t border-line bg-white px-5 py-4 md:hidden" data-id="element-139" data-mp="rcpycgtf2ra3">
            <ul className="flex flex-col" data-id="element-140" data-mp="1578wgg2bv8ml">
              {navItems.map(item => <li key={item.href} className="border-b border-line-soft last:border-b-0" data-id="element-141" data-mp="105jlt1j0owz1">
                  <a href={item.href} onClick={() => setMenuOpen(false)} className="block py-3.5 text-center font-sans text-[12px] uppercase tracking-luxe text-maroon" data-id="element-142" data-mp="1f2trtvcw5and">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>}
      </div>
    </header>;
}